module.exports = __webpack_public_path__ + "img/oufu_86x100x10b.prt.6d74c4c9.jpg";